<template>
  <div
    :class="notificationColorClass"
    class="tw:border-0 tw:flex tw:items-center tw:justify-start tw:border tw:rounded-lg tw:px-3 tw:py-3"
  >
    <Bulb v-if="type === 'info'" class="tw:w-3 tw:h-5" />
    <ExclamationTriangleLine v-if="type === 'warning'" class="tw:size-[18px]" />
    <CloseOutline v-if="type === 'error'" class="tw:size-[18px]" />

    <div class="tw:ml-3">
      <p class="tw:text-sm" v-html="$t(text)" />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import Bulb from '@/components/icons/Bulb.svg?component'
import ExclamationTriangleLine from '@/components/icons/ExclamationTriangleLine.svg?component'
import CloseOutline from '@/components/icons/CloseOutline.svg?component'

const props = defineProps({
  text: String,
  type: String,
})

const notificationColorClass = computed(() => {
  if (props.type === 'error') return 'tw:bg-red-200'
  if (props.type === 'warning') return 'tw:bg-orange-200'
  else return 'tw:bg-blue-200'
})
</script>
